module.exports = {
  'changeDraftDescription-default': require('./changeDraftDescription-default.json'),
  'changeEvent-blackKeys': require('./changeEvent-blackKeys.json'),
  'changeEvent-default': require('./changeEvent-default.json'),
  'changeEvent-empty': require('./changeEvent-empty.json'),
  'changeEventType-default': require('./changeEventType-default.json'),
  'changeSeating-default': require('./changeSeating-default.json'),
  'changeSeating-firstTicket': require('./changeSeating-firstTicket.json'),
  'changeSeating-secondTicket': require('./changeSeating-secondTicket.json'),
  'changeUserPayoutMethod-default': require('./changeUserPayoutMethod-default.json'),
  'changeUserPayoutMethod-listingOtherCurrency': require('./changeUserPayoutMethod-listingOtherCurrency.json'),
  'changeUserPayoutMethod-currencyMismatch': require('./changeUserPayoutMethod-currencyMismatch.json'),
  'changeUserPayoutMethod-notOldEnough': require('./changeUserPayoutMethod-notOldEnough.json'),
  'changePlatformAccountFields-default': require('./changePlatformAccountFields-default.json'),
  'changePlatformAccountFields-wrongData': require('./changePlatformAccountFields-wrongData.json'),
  'changeOriginalPrice-withGBP': require('./changeOriginalPrice-withGBP.json'),
  'changeOriginalPrice-default': require('./changeOriginalPrice-default.json'),
  'generateAuthToken-default': require('./generateAuthToken-default.json'),
  'getActiveDraft-empty': require('./getActiveDraft-empty.json'),
  'getActiveDraft-withEvent': require('./getActiveDraft-withEvent.json'),
  'getDraft-empty': require('./getDraft-empty.json'),
  'getDraft-withEvent': require('./getDraft-withEvent.json'),
  'getDraft-withUSBank': require('./getDraft-withUSBank.json'),
  'getDraft-withResell': require('./getDraft-withResell.json'),
  'getDraft-withFiles': require('./getDraft-withFiles.json'),
  'getDraft-withTicket': require('./getDraft-withTicket.json'),
  'getDraft-withTickets': require('./getDraft-withTickets.json'),
  'getDraft-withOriginalPrice': require('./getDraft-withOriginalPrice.json'),
  'getDraft-withSellingPrice': require('./getDraft-withSellingPrice.json'),
  'getDraft-withSeating': require('./getDraft-withSeating.json'),
  'getDraft-withTicketWarning': require('./getDraft-withTicketWarning.json'),
  'getDraft-withSocials': require('./getDraft-withSocials.json'),
  'getDraft-withAvatar': require('./getDraft-withAvatar.json'),
  'getDraft-withPhonenumber': require('./getDraft-withPhonenumber.json'),
  'getDraft-withAll': require('./getDraft-withAll.json'),
  'getEventData-default': require('./getEventData-default.json'),
  'getEventData-organizer': require('./getEventData-organizer.json'),
  'getEventTypeData-default': require('./getEventTypeData-default.json'),
  'getHomepageAnnouncement-default': require('./getHomepageAnnouncement-default.json'),
  'getPayoutForm-us': require('./getPayoutForm-us.json'),
  'getPopularEvents-default': require('./getPopularEvents-default.json'),
  'getPopularVenues-default': require('./getPopularVenues-default.json'),
  'getRandomCover-default': require('./getRandomCover-default.json'),
  'getTestimonials-default': require('./getTestimonials-default.json'),
  'getUsercountAndAvatars-default': require('./getUsercountAndAvatars-default.json'),
  'getViewerInfo-loggedIn': require('./getViewerInfo-loggedIn.json'),
  'getViewerInfo-loggedOut': require('./getViewerInfo-loggedOut.json'),
  'getViewerInfo-loggedInEmployee': require('./getViewerInfo-loggedInEmployee.json'),
  'registerUserUsingEmail-default': require('./registerUserUsingEmail-default.json'),
  'searchEvents-default': require('./searchEvents-default.json'),
  'searchEvents-najib': require('./searchEvents-najib.json'),
  'searchEvents-noResults': require('./searchEvents-noResults.json'),
  'sendLoginLink-newUser': require('./sendLoginLink-newUser.json'),
  'getAvailableListings-default': require('./getAvailableListings-default.json'),
  'getSoldListings-default': require('./getSoldListings-default.json'),
  'getWantedListings-default': require('./getWantedListings-default.json'),
  'createTicketAlert-default': require('./createTicketAlert-default.json'),
  'removeTicketAlert-default': require('./removeTicketAlert-default.json'),
  'createDraft-fromEventType': require('./createDraft-fromEventType.json'),
  'getCartAndListing-default': require('./getCartAndListing-default.json'),
  'searchLocation-default': require('./searchLocation-default.json'),
  'similarEvents-empty': require('./similarEvents-empty.json'),
  'similarEvents-default': require('./similarEvents-default.json'),
  'createEvent-default': require('./createEvent-default.json'),
  'changeEvent-createdEvent': require('./changeEvent-createdEvent.json'),
  'getBusinessInfo-default': require('./getBusinessInfo-default.json'),
  'changeDraftToResellDraft-default': require('./changeDraftToResellDraft-default.json'),
  'changeDraftToResellDraft-multipleFiles': require('./changeDraftToResellDraft-multipleFiles.json'),
  'changeDraftPromotionSettings-withoutTwitter': require('./changeDraftPromotionSettings-withoutTwitter.json'),
  'changeDraftPromotionSettings-withTwitter': require('./changeDraftPromotionSettings-withTwitter.json'),
  'changeUserAvatar-default': require('./changeUserAvatar-default.json'),
  'setNewDraftSellingPrice-withGBP': require('./setNewDraftSellingPrice-withGBP.json'),
  'setNewDraftSellingPrice-default': require('./setNewDraftSellingPrice-default.json'),
  'changeSellingPrice-tooLowPrice': require('./changeSellingPrice-tooLowPrice.json'),
  'changeSellingPrice-maximumPrice': require('./changeSellingPrice-maximumPrice.json'),
  'changeSellingPrice-unsupportedCurrency': require('./changeSellingPrice-unsupportedCurrency.json'),
  'changeSellingPrice-dollars': require('./changeSellingPrice-dollars.json'),
  'changeUserPhone-default': require('./changeUserPhone-default.json'),
  'changeUserPhone-uk': require('./changeUserPhone-uk.json'),
  'sendUserVerificationCode-default': require('./sendUserVerificationCode-default.json'),
  'sendUserVerificationCode-uk': require('./sendUserVerificationCode-uk.json'),
  'skipUserPhoneVerification-default': require('./skipUserPhoneVerification-default.json'),
  'verifyUserPhone-default': require('./verifyUserPhone-default.json'),
  'verifyUserPhone-wrong': require('./verifyUserPhone-wrong.json'),
  'preparePublication-default': require('./preparePublication-default.json'),
  'draftPublishState-notReadyToPublish': require('./draftPublishState-notReadyToPublish.json'),
  'draftPublishState-readyToPublish': require('./draftPublishState-readyToPublish.json'),
  'draftPublishState-verificationErrors': require('./draftPublishState-verificationErrors.json'),
  'makeDraftPrivate-default': require('./makeDraftPrivate-default.json'),
  'createNewDraft-default': require('./createNewDraft-default.json'),
  'addFileToDraft-default': require('./addFileToDraft-default.json'),
  'removeDraftFile-default': require('./removeDraftFile-default.json'),
  'changeDraftTicketType-default': require('./changeDraftTicketType-default.json'),
  'changeDraftTicketForSale-default': require('./changeDraftTicketForSale-default.json'),
  'publishDraft-default': require('./publishDraft-default.json'),
  'getPublishedDraft-default': require('./getPublishedDraft-default.json'),
  'startUserEmailVerification-default': require('./startUserEmailVerification-default'),
  'getViewerInfo-withSocialConnect': require('./getViewerInfo-withSocialConnect'),
  'disconnectSocialFacebook-default': require('./disconnectSocialFacebook-default'),
  'getViewerInfo-removeProfile': require('./getViewerInfo-removeProfile'),
  'exportUserData-default': require('./exportUserData-default'),
  'showSearchResults-default': require('./showSearchResults-default.json'),
  'addTicketsToCart-default': require('./addTicketsToCart-default.json'),
  'changePaymentMethod-default': require('./changePaymentMethod-default'),
  'getCheckout-default': require('./getCheckout-default'),
  'changePaymentMethod-withBank': require('./changePaymentMethod-withBank'),
  'startCheckoutPayment-default': require('./startCheckoutPayment-default'),
  'getPaymentStatus-successfulPayment': require('./getPaymentStatus-successfulPayment'),
  'getCheckout-pendingBank': require('./getCheckout-pendingBank'),
  'getViewer-withBoughtTicket': require('./getViewer-withBoughtTicket'),
  'checkPurchases-default': require('./checkPurchases-default'),
  'getListingsForViewer-default': require('./getListingsForViewer-default'),
  'getOrganizerProducts-default': require('./getOrganizerProducts-default'),
  'getOrganizerProduct-default': require('./getOrganizerProduct-default'),
  'getOrganizerProduct-creditCard': require('./getOrganizerProduct-creditCard'),
  'getFeedItems-loggedOut': require('./getFeedItems-loggedOut'),
}
